// extracted by mini-css-extract-plugin
export default {"section":"Section-module--section--0736c","change":"Section-module--change--0c50a"};